import { PageStepType } from './PageTypes';
import { DataTools } from '../utils/DataTools';
import { StringOptions } from '../utils/StringOptions';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { LangServices } from '../utils/LangServices';

let _keyAssignment: number = 1000;

export abstract class StepBase
{
	// unique key assigned to each StepBase element
	// can be used for tracking or state or React keys
	key_id: string;

	raw: PageStepType;
	isAsync: boolean;

	/** Language based text, should select the correct country in the future */
	text: string;
	options: StringOptions;

	option_1: string;
	option_2: string;
	field_id: string;

	/** Returns true if the step has the option defined */
	hasOptions(strOptionName: string)
	{
		if (!this.options) return false;
		if (this.options.checkOption(strOptionName)) return true;
		return false;
	}

	constructor(rawData: PageStepType)
	{
		this.raw = rawData;
		this.isAsync = false;

		this.options = new StringOptions(this.raw.step_option);

		// In the future select with "text_" + lang
		this.text = rawData.text_en ? rawData.text_en : '';

		// Check for language setting
		const langCodeShort = LangServices.currentLanguage.short_code.toLowerCase();
		const langCode = LangServices.currentLanguage.code.toLowerCase();
		if (langCodeShort != "en")
		{
			// User is set to something that is not English
			if ((rawData as any)[`text_${langCode}`])
			{
				this.text = (rawData as any)[`text_${langCode}`];
			} else if ((rawData as any)[`text_${langCodeShort}`])
			{
				this.text = (rawData as any)[`text_${langCodeShort}`];
			}
		}

		// Assign a unique key with a global counter
		_keyAssignment++;
		this.key_id = 'STEP' + _keyAssignment.toString();

		if (this.raw.option_1) this.option_1 = this.raw.option_1;
		else this.option_1 = '';

		if (this.raw.option_2) this.option_2 = this.raw.option_2;
		else this.option_2 = '';

		if (this.raw.field_id) this.field_id = this.raw.field_id;
		else this.field_id = '';
	}

	/**
	 * Post process the step
	 */
	async processStep(logic: LogicEngine): Promise<boolean>
	{
		this.text = logic.processTextReplacement(this.text);
		return true;
	}
}
